module.exports = __webpack_public_path__ + "static/contemporary-rug-categories-1a260743c8eee1300345016a9ea85740.jpg";